/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArtifactTranscriptionFromJSON(json) {
    return StreemApiArtifactTranscriptionFromJSONTyped(json, false);
}
export function StreemApiArtifactTranscriptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : json['status'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'startedAt': !exists(json, 'started_at') ? undefined : (new Date(json['started_at'])),
        'erroredAt': !exists(json, 'errored_at') ? undefined : (new Date(json['errored_at'])),
        'fulfilledAt': !exists(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
    };
}
export function StreemApiArtifactTranscriptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'storage_url': value.storageUrl,
        'started_at': value.startedAt === undefined ? undefined : (value.startedAt.toISOString()),
        'errored_at': value.erroredAt === undefined ? undefined : (value.erroredAt.toISOString()),
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'type': value.type,
        'url': value.url,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'source': value.source,
        'sid': value.sid,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactTranscriptionStatus;
(function (StreemApiArtifactTranscriptionStatus) {
    StreemApiArtifactTranscriptionStatus["CAPTURED"] = "STATUS_CAPTURED";
    StreemApiArtifactTranscriptionStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactTranscriptionStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactTranscriptionStatus["REJECTED"] = "STATUS_REJECTED";
    StreemApiArtifactTranscriptionStatus["STARTED"] = "STATUS_STARTED";
    StreemApiArtifactTranscriptionStatus["UNKNOWN"] = "STATUS_UNKNOWN";
})(StreemApiArtifactTranscriptionStatus || (StreemApiArtifactTranscriptionStatus = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactTranscriptionType;
(function (StreemApiArtifactTranscriptionType) {
    StreemApiArtifactTranscriptionType["TXT"] = "TXT";
    StreemApiArtifactTranscriptionType["VTT"] = "VTT";
})(StreemApiArtifactTranscriptionType || (StreemApiArtifactTranscriptionType = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactTranscriptionSource;
(function (StreemApiArtifactTranscriptionSource) {
    StreemApiArtifactTranscriptionSource["AWS"] = "AWS";
    StreemApiArtifactTranscriptionSource["INVALID"] = "INVALID";
    StreemApiArtifactTranscriptionSource["WHISPER"] = "WHISPER";
})(StreemApiArtifactTranscriptionSource || (StreemApiArtifactTranscriptionSource = {}));
//# sourceMappingURL=StreemApiArtifactTranscription.js.map